import { computed, useContext } from '@nuxtjs/composition-api'

export type UserAgreementModel = {
  email?: string
  phone?: string
  agreement?: undefined | null | boolean
}

const useLogUserAgreement = () => {
  const context = useContext()
  const clientIp = computed(() => context.store.getters['userIp/GET_USER_IP'])
  return async (model: UserAgreementModel) => {
    try {
      const req = {
        email: model.email,
        phone: model.phone,
        agreement: String(model.agreement || false),
        siteUrl: window.location.href,
        dateTime: new Date().toISOString(),
        clientIp: clientIp.value,
      }
      const response = await context.$api.requests.logMarketingAgreement(req)
      return response.data?.success || false
    } catch (e) {
      console.error('LOG USER AGREEMENT ERROR', e)
    }
    return false
  }
}

export default useLogUserAgreement
